import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X, AlertTriangle, CreditCard, Clock } from "lucide-react";
import { cn } from "@/lib/utils";

interface PendingPaymentBannerProps {
  count: number;
  itemName?: string;
  amount?: number;
  onDismiss: () => void;
  className?: string;
}

export function PendingPaymentBanner({
  count,
  itemName,
  amount,
  onDismiss,
  className,
}: PendingPaymentBannerProps) {
  const navigate = useNavigate();

  const handlePayNow = () => {
    navigate("/payments");
  };

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-50 bg-amber-500/95 text-amber-950 px-4 py-3 shadow-lg backdrop-blur-sm",
        className
      )}
    >
      <div className="container mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-amber-600/20">
            <AlertTriangle className="h-4 w-4" />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
            <span className="font-medium">
              {count === 1
                ? "You have 1 pending payment"
                : `You have ${count} pending payments`}
            </span>
            {itemName && amount && (
              <span className="text-sm text-amber-800">
                • {itemName} • ${(amount / 100).toFixed(2)}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="secondary"
            onClick={handlePayNow}
            className="bg-amber-950 text-amber-50 hover:bg-amber-900"
          >
            <CreditCard className="h-4 w-4 mr-2" />
            Complete Payment
          </Button>
          <Button
            size="icon"
            variant="ghost"
            onClick={onDismiss}
            className="h-8 w-8 text-amber-800 hover:text-amber-950 hover:bg-amber-600/20"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
